import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // Check if member is authenticated by looking for token in localStorage
  const isAuthenticated = () => {
    const token = localStorage.getItem('memberToken');
    const member = localStorage.getItem('member');

    if (!token || !member) {
      return false;
    }

    // Verify token hasn't expired (optional, but good practice)
    try {
      const memberData = JSON.parse(member);
      return !!memberData.email; // Basic validation
    } catch {
      return false;
    }
  };

  return isAuthenticated() ? children : <Navigate to="/member-login" replace />;
};

export default ProtectedRoute;